export default "__VITE_ASSET__BtHA40xr__"